export default {
    "en" : {
      'scan_doc':'Scan documents easily<br> with Scanner PDF!',
      'continue':'Continue',
      'extract':'Extract, edit and share!<br> E-sign and add stamps.',
      'worked':'Worked really well for me',
      'with_scanner':'With Scanner app I got the most similar<br> thing to an actual scanned document.',
      'name1':'Chris Beake',
      'loved':'Loved by<br> 11 mln people',
      'reviews':'19,500 reviews',
      'raeting':'4.6',
      'best_scanner':'Best scanner app',
      'found':'Found this after trying more<br> than 5 similar apps!',
      'name2':'Jeanne Yates',
      'pp':'Privacy Policy',
      'and':'and',
      'tos':'Terms of Use',
      'use_4_apps':'Use 4 apps!',
      'use_3_apps':'Use 3 apps!',
      'trial':'3-day Free trial >',
      'price_line':'Then {price} week',
      'successful':'Successful!',
      'your_account':'Your account was activated.<br> Tap to download.',

      'scan_edit':'Scan, edit, e-sign and share docs.<br> Extract text with OCR. Send faxes and<br> use cloud storage.',
      'create_as_many':'Create as many invoices as you need<br> and share them with your clients<br> in a wink.',
      'record_your':'Record your incoming and outgoing<br> calls. Manage and share your records<br> in one tap.',
      'protect_privacy':'Protect privacy and get rid of disturbing<br> calls with SIM-free second phone<br> number app.',

      'please_add_card':'Please add card to<br> Apple Pay and try again',
      'add_card':'Add Сard',
      'done':'Done',

      'un_leave':'Are you sure<br> you want to leave us?',
      'un_unsubscribe':'Unsubscribe',
      'un_keep':'Keep Premium',
      'un_lost':"You've lost Premium",
      'un_succ':'You have successfully<br> unsubscribed.',
      'un_start':'Start Over',
      'un_keept':"You've kept Premium!",
      'un_remained':"You've remained<br> Scanner Premium user.",

      'use_sc':'Use Scanner PDF!',
      'use_iv':'Use Invoice maker app!',
      'use_cr':'Use Call Recorder for Me!',
      'use_spn':'Use Second Phone Number!',

      'scan_edit':'Scan, edit, e-sign and stamp docs.<br> Extract and translate text with OCR.<br> Share documents easily.',

      'need_refound':'Need a refund?',
      'may_loose':'You may lose access<br> to purchased items and content.',     
      'please_describe':'Please, describe your case:',
      'tell_us_reason':'Tell us the reason why you want a refund',
      'send_request':'Send request',
      'request_sent':'Request sent!',
      'we_received':`We've received your refund request and get back to you as soon as possible. The request will be processed within 3-5 business days.`,
      'ok_got_it':'Ok, got it',

      "cancel":'Cancel',

      "skin_check":'Check your moles<br> with AI technology',
      "skin_features":`✅ CE Marked as a medical device<br> ✅ 95% algorithm's accuracy`,
      "skin_see_results":'See results',
      "skin_get_reliable":'Get a reliable result<br> in 15 seconds',
      "skin_dr":'Dr. Chris Beake',
      "skin_many":'Many users were unaware of risk when<br> they detected skin diseases with the app.',
      "skin_moles":'Check your moles',
      "skin_scan_save":'Scan, save and share',
      "skin_record":'Record your calls',
      "skin_get_second":'Get second phone number',
      "skin_scan_edit":'Scan, edit, e-sign and stamp docs.<br> Extract and translate text with OCR.<br> Share documents easily.',
      "skin_make":'Make skin monitoring a simple routine.<br> Find signs of diseases and contact your<br> healthcare provider in time.',

      "upgrade_please":'Please upgrade your<br> device to iOS 13 or above',
      "upgrade_settings":'Go to Settings',

      "premium_premium":`You're already a<br>Scanner Premium member.`,
      "premium_download":'Go to App Store'
    },
    "cn" : {
      'scan_doc':'轻松扫描文档<br>用扫描仪PDF',
      'continue':'下一步',
      'extract':'提取、编辑和分享！<br>电子签名和盖章',
      'worked':'我觉得它超好用',
      'with_scanner':'用扫描仪软件，我获得了最接近原件的<br>扫描文档',
      'name1':'李涛',
      'loved':'被1000万人<br>钟爱',
      'reviews':'19500条评论',
      'raeting':'4.6',
      'best_scanner':'最好的扫描App',
      'found':'在试用了5款相似应用后<br>得出的结论',
      'name2':'王丽',
      'pp':'隐私政策',
      'and':'和',
      'tos':'使用条款',
      'use_4_apps':'使用4款App',
      'use_3_apps':'使用3款App',
      'trial':'三天免费试用 >',
      'price_line':'之后{price}一周',
      'successful':'成功！',
      'your_account':'你的账户已激活<br>点击下载',

      'scan_edit':'扫描、编辑、电子签名和文档分享<br>OCR技术识别文本，发送传真和<br>使用云端储存',
      'create_as_many':'制作发票数量任你所需，<br>瞬间分享给你的客户',
      'record_your':'轻松进行通话录音，<br>点击即可管理你的录音并分享',
      'protect_privacy':'使用无SIM卡的第二个电话号码<br>为您摆脱骚扰电话，并保护您的隐私',

      'please_add_card':'请在Apple Pay添加<br>银行卡后重试',
      'add_card':'添加卡片',
      'done':'完成',

      'un_leave':'你确定<br>你想离开？',
      'un_unsubscribe':'退订',
      'un_keep':'保持会员资格',
      'un_lost':"你失去了会员资格",
      'un_succ':'你已成功<br>退订',
      'un_start':'重来',
      'un_keept':"你已续费！",
      'un_remained':"你仍是<br>扫描仪高级会员",

      'use_sc':'使用扫描仪PDF',
      'use_iv':'使用发票制作App!',
      'use_cr':'使用通话录音',
      'use_spn':'使用第二个手机号码',

      'scan_edit':'扫描、编辑、电子签名和文件印章，<br>利用OCR技术提取和翻译文本，<br>分享文档超方便',

      "cancel":'取消',

      'need_refound':'需要退款？',
      'may_loose':'你可能会无法访问已购买的项目和内容',     
      'please_describe':'请描述一下你的情况：',
      'tell_us_reason':'告诉我们你想退款的原因',
      'send_request':'发送请求',
      'request_sent':'请求已发送！',
      'we_received':`我们收到你的退款请求，并尽快与你联系。该请求将在3-5天个工作日内被处理。`,
      'ok_got_it':'好的，明白了',

      "skin_check":'利用AI技术<br>检查你的痣',
      "skin_features":`✅ CE印记作为医疗器械<br>✅ 95%算法准确率`,
      "skin_see_results":'查看结果',
      "skin_get_reliable":'获得可靠的结果<br>在15秒内',
      "skin_dr":'李伟医生',
      "skin_many":'很多用户在用这款app检测皮肤时，<br>他们并没有意识到风险',
      "skin_moles":'检查你的痣',
      "skin_scan_save":'扫描、保存和分享',
      "skin_record":'录音你的通话',
      "skin_get_second":'获取第二个电话号码',
      "skin_scan_edit":'扫描、编辑、电子签名和文件印章，<br>利用OCR技术提取和翻译文本，<br>分享文档超方便',
      "skin_make":'让皮肤监测成为日常例行事项，<br>发现疾病痕迹并能及时联系你的<br>皮肤科医生',

      "upgrade_please":'请将您的设备升级至<br> iOS 13 或以上版本',
      "upgrade_settings":'前往“设置”',

      "premium_premium":`你已经是Scanner的高端会员了`,
      "premium_download":'前往App Store'
    }
}